import * as React from 'react';
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Drawer,
  makeStyles,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import MenuList from "./MenuList";
import { drawerWidth } from "../../../store/constant";
const useStyles = makeStyles(theme => ({
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  drawerPaper: {
    width: drawerWidth,
    color: theme.palette.text.primary,
    borderRight: "none",
    [theme.breakpoints.up("md")]: {
      top: "88px"
    }
  },
  ScrollHeight: {
    height: "calc(100vh - 88px)",
    paddingLeft: "10px",
    paddingRight: "10px",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)"
    }
  },
  boxContainer: {
    display: "flex",
    padding: "10px",
    marginLeft: "auto",
    marginRight: "auto"
  }
}));
interface SidebarProps {
  drawerOpen: boolean;
  drawerToggle: () => void;
  window?: ()=>Window
}
const Sidebar = (props: SidebarProps) => {
  const { drawerOpen, drawerToggle, window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const drawer = (
    <React.Fragment>
      <PerfectScrollbar className={classes.ScrollHeight}>
        <MenuList /> 
      </PerfectScrollbar>
    </React.Fragment>
  );
  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant={matchUpMd ? "persistent" : "temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        classes={{
          paper: classes.drawerPaper
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </nav>
  );
};
export default Sidebar;
